import { render, staticRenderFns } from "./ChangeDueDateDialog.vue?vue&type=template&id=86e262fc"
import script from "./ChangeDueDateDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeDueDateDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChangeDueDateDialog.vue?vue&type=style&index=0&id=86e262fc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports